import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/all-icon.svg'
import _imports_1 from '@/assets/images/electronics-icon2.svg'
import _imports_2 from '@/assets/images/clothing-icon2.svg'
import _imports_3 from '@/assets/images/beauty-icon.svg'
import _imports_4 from '@/assets/images/foods-icon.svg'
import _imports_5 from '@/assets/images/product-36.png'
import _imports_6 from '@/assets/images/product-37.png'
import _imports_7 from '@/assets/images/product-38.png'
import _imports_8 from '@/assets/images/product-39.png'
import _imports_9 from '@/assets/images/product-40.png'
import _imports_10 from '@/assets/images/product-41.png'
import _imports_11 from '@/assets/images/product-42.png'
import _imports_12 from '@/assets/images/product-43.png'
import _imports_13 from '@/assets/images/product-44.png'


const _hoisted_1 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_2 = {
  class: "tab-pane fade show active",
  id: "all-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "all-tab",
  tabindex: "0"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 col-sm-6" }
const _hoisted_5 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_6 = { class: "pb-1" }
const _hoisted_7 = { class: "col-md-4 col-sm-6" }
const _hoisted_8 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_9 = { class: "pb-1" }
const _hoisted_10 = { class: "col-md-4 col-sm-6" }
const _hoisted_11 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_12 = { class: "pb-1" }
const _hoisted_13 = { class: "col-md-4 col-sm-6" }
const _hoisted_14 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_15 = { class: "pb-1" }
const _hoisted_16 = { class: "col-md-4 col-sm-6" }
const _hoisted_17 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_18 = { class: "pb-1" }
const _hoisted_19 = { class: "col-md-4 col-sm-6" }
const _hoisted_20 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_21 = { class: "pb-1" }
const _hoisted_22 = { class: "col-md-4 col-sm-6" }
const _hoisted_23 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_24 = { class: "pb-1" }
const _hoisted_25 = { class: "col-md-4 col-sm-6" }
const _hoisted_26 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_27 = { class: "pb-1" }
const _hoisted_28 = { class: "col-md-4 col-sm-6" }
const _hoisted_29 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_30 = { class: "pb-1" }
const _hoisted_31 = {
  class: "tab-pane fade",
  id: "electronics-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "electronics-tab",
  tabindex: "0"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-4 col-sm-6" }
const _hoisted_34 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_35 = { class: "pb-1" }
const _hoisted_36 = { class: "col-md-4 col-sm-6" }
const _hoisted_37 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_38 = { class: "pb-1" }
const _hoisted_39 = { class: "col-md-4 col-sm-6" }
const _hoisted_40 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_41 = { class: "pb-1" }
const _hoisted_42 = { class: "col-md-4 col-sm-6" }
const _hoisted_43 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_44 = { class: "pb-1" }
const _hoisted_45 = { class: "col-md-4 col-sm-6" }
const _hoisted_46 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_47 = { class: "pb-1" }
const _hoisted_48 = { class: "col-md-4 col-sm-6" }
const _hoisted_49 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_50 = { class: "pb-1" }
const _hoisted_51 = {
  class: "tab-pane fade",
  id: "clothing-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "clothing-tab",
  tabindex: "0"
}
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-md-4 col-sm-6" }
const _hoisted_54 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_55 = { class: "pb-1" }
const _hoisted_56 = { class: "col-md-4 col-sm-6" }
const _hoisted_57 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_58 = { class: "pb-1" }
const _hoisted_59 = { class: "col-md-4 col-sm-6" }
const _hoisted_60 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_61 = { class: "pb-1" }
const _hoisted_62 = { class: "col-md-4 col-sm-6" }
const _hoisted_63 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_64 = { class: "pb-1" }
const _hoisted_65 = { class: "col-md-4 col-sm-6" }
const _hoisted_66 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_67 = { class: "pb-1" }
const _hoisted_68 = { class: "col-md-4 col-sm-6" }
const _hoisted_69 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_70 = { class: "pb-1" }
const _hoisted_71 = {
  class: "tab-pane fade",
  id: "beauty-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "beauty-tab",
  tabindex: "0"
}
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-md-4 col-sm-6" }
const _hoisted_74 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_75 = { class: "pb-1" }
const _hoisted_76 = { class: "col-md-4 col-sm-6" }
const _hoisted_77 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_78 = { class: "pb-1" }
const _hoisted_79 = { class: "col-md-4 col-sm-6" }
const _hoisted_80 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_81 = { class: "pb-1" }
const _hoisted_82 = { class: "col-md-4 col-sm-6" }
const _hoisted_83 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_84 = { class: "pb-1" }
const _hoisted_85 = { class: "col-md-4 col-sm-6" }
const _hoisted_86 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_87 = { class: "pb-1" }
const _hoisted_88 = { class: "col-md-4 col-sm-6" }
const _hoisted_89 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_90 = { class: "pb-1" }
const _hoisted_91 = {
  class: "tab-pane fade",
  id: "foods-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "foods-tab",
  tabindex: "0"
}
const _hoisted_92 = { class: "row justify-content-center" }
const _hoisted_93 = { class: "col-md-4 col-sm-6" }
const _hoisted_94 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_95 = { class: "pb-1" }
const _hoisted_96 = { class: "col-md-4 col-sm-6" }
const _hoisted_97 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_98 = { class: "pb-1" }
const _hoisted_99 = { class: "col-md-4 col-sm-6" }
const _hoisted_100 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_101 = { class: "pb-1" }
const _hoisted_102 = { class: "col-md-4 col-sm-6" }
const _hoisted_103 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_104 = { class: "pb-1" }
const _hoisted_105 = { class: "col-md-4 col-sm-6" }
const _hoisted_106 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_107 = { class: "pb-1" }
const _hoisted_108 = { class: "col-md-4 col-sm-6" }
const _hoisted_109 = { class: "card custom-shadow rounded-3 border mb-4 bg-white p-20" }
const _hoisted_110 = { class: "pb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[71] || (_cache[71] = _createElementVNode("h3", { class: "fs-20 fw-medium mb-4" }, "Categories", -1)),
    _cache[72] || (_cache[72] = _createElementVNode("ul", {
      class: "nav nav-tabs border-0 mb-4 gap-3 categories-tabs",
      id: "myTab",
      role: "tablist"
    }, [
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link border-2 bg-transparent rounded-3 active",
          style: {"width":"125px","padding":"20px","padding-bottom":"16px"},
          id: "all-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#all-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "all-tab-pane",
          "aria-selected": "true"
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "mb-3",
            alt: "all-icon"
          }),
          _createElementVNode("h4", { class: "fs-16 fw-medium d-block mb-0" }, "All"),
          _createElementVNode("span", { class: "fs-12 fw-medium text-body" }, [
            _createTextVNode(" 450 "),
            _createElementVNode("span", { class: "d-none" }, "Products")
          ])
        ])
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link border-2 bg-transparent rounded-3",
          style: {"width":"125px","padding":"20px","padding-bottom":"16px"},
          id: "electronics-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#electronics-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "electronics-tab-pane",
          "aria-selected": "false"
        }, [
          _createElementVNode("img", {
            src: _imports_1,
            class: "mb-3",
            alt: "electronics-icon"
          }),
          _createElementVNode("h4", { class: "fs-16 fw-medium d-block mb-0" }, "Electronics"),
          _createElementVNode("span", { class: "fs-12 fw-medium text-body" }, [
            _createTextVNode(" 45 "),
            _createElementVNode("span", { class: "d-none" }, "Products")
          ])
        ])
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link border-2 bg-transparent rounded-3",
          style: {"width":"125px","padding":"20px","padding-bottom":"16px"},
          id: "clothing-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#clothing-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "clothing-tab-pane",
          "aria-selected": "false"
        }, [
          _createElementVNode("img", {
            src: _imports_2,
            class: "mb-3",
            alt: "clothing-icon2"
          }),
          _createElementVNode("h4", { class: "fs-16 fw-medium d-block mb-0" }, "Clothing"),
          _createElementVNode("span", { class: "fs-12 fw-medium text-body" }, [
            _createTextVNode(" 29 "),
            _createElementVNode("span", { class: "d-none" }, "Products")
          ])
        ])
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link border-2 bg-transparent rounded-3",
          style: {"width":"125px","padding":"20px","padding-bottom":"16px"},
          id: "beauty-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#beauty-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "beauty-tab-pane",
          "aria-selected": "false"
        }, [
          _createElementVNode("img", {
            src: _imports_3,
            class: "mb-3",
            alt: "beauty-icon"
          }),
          _createElementVNode("h4", { class: "fs-16 fw-medium d-block mb-0" }, "Beauty"),
          _createElementVNode("span", { class: "fs-12 fw-medium text-body" }, [
            _createTextVNode(" 34 "),
            _createElementVNode("span", { class: "d-none" }, "Products")
          ])
        ])
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link border-2 bg-transparent rounded-3",
          style: {"width":"125px","padding":"20px","padding-bottom":"16px"},
          id: "foods-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#foods-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "foods-tab-pane",
          "aria-selected": "false"
        }, [
          _createElementVNode("img", {
            src: _imports_4,
            class: "mb-3",
            alt: "foods-icon"
          }),
          _createElementVNode("h4", { class: "fs-16 fw-medium d-block mb-0" }, "Foods"),
          _createElementVNode("span", { class: "fs-12 fw-medium text-body" }, [
            _createTextVNode(" 18 "),
            _createElementVNode("span", { class: "d-none" }, "Products")
          ])
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Apple iPhone 16", -1),
                    _createElementVNode("span", { class: "text-body" }, "Smartphones", -1)
                  ])),
                  _: 1
                }),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$799"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      src: _imports_6,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Levi's 501", -1),
                    _createElementVNode("span", { class: "text-body" }, "Pants", -1)
                  ])),
                  _: 1
                }),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$89"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("img", {
                      src: _imports_7,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Maybelline Lash", -1),
                    _createElementVNode("span", { class: "text-body" }, "Makeup", -1)
                  ])),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$29"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("img", {
                      src: _imports_8,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Quaker Oats", -1),
                    _createElementVNode("span", { class: "text-body" }, "Breakfast", -1)
                  ])),
                  _: 1
                }),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$99"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createElementVNode("img", {
                      src: _imports_9,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Fitbit Charge", -1),
                    _createElementVNode("span", { class: "text-body" }, "Wearables", -1)
                  ])),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$179"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createElementVNode("img", {
                      src: _imports_10,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Adidas Women", -1),
                    _createElementVNode("span", { class: "text-body" }, "Outerwear", -1)
                  ])),
                  _: 1
                }),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$85"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("img", {
                      src: _imports_11,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Galaxy Tab", -1),
                    _createElementVNode("span", { class: "text-body" }, "Tablets", -1)
                  ])),
                  _: 1
                }),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$649"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createElementVNode("img", {
                      src: _imports_12,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "H&M Basic", -1),
                    _createElementVNode("span", { class: "text-body" }, "T-Shirts", -1)
                  ])),
                  _: 1
                }),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$20"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createElementVNode("img", {
                      src: _imports_13,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "L'Oréal Paris", -1),
                    _createElementVNode("span", { class: "text-body" }, "Makeup", -1)
                  ])),
                  _: 1
                }),
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$69"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap custom-shadow for-dark-rounded-bg rounded-3 border bg-white px-4 mb-4\" style=\"padding-top:11px;padding-bottom:11px;\"><span class=\"fs-12 fw-medium\">Showing 9 of 30 Results</span><nav aria-label=\"Page navigation example\"><ul class=\"pagination mb-0 justify-content-center\"><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Previous\"><i class=\"material-symbols-outlined\">keyboard_arrow_left</i></button></li><li class=\"page-item\"><button class=\"page-link active\">1</button></li><li class=\"page-item\"><button class=\"page-link\">2</button></li><li class=\"page-item\"><button class=\"page-link\">3</button></li><li class=\"page-item\"><a class=\"page-link\">4</a></li><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Next\"><i class=\"material-symbols-outlined\">keyboard_arrow_right</i></button></li></ul></nav></div>", 1))
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createElementVNode("img", {
                      src: _imports_9,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Fitbit Charge", -1),
                    _createElementVNode("span", { class: "text-body" }, "Wearables", -1)
                  ])),
                  _: 1
                }),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$179"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Apple iPhone 16", -1),
                    _createElementVNode("span", { class: "text-body" }, "Smartphones", -1)
                  ])),
                  _: 1
                }),
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$799"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createElementVNode("img", {
                      src: _imports_11,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Galaxy Tab", -1),
                    _createElementVNode("span", { class: "text-body" }, "Tablets", -1)
                  ])),
                  _: 1
                }),
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$649"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createElementVNode("img", {
                      src: _imports_6,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Levi's 501", -1),
                    _createElementVNode("span", { class: "text-body" }, "Pants", -1)
                  ])),
                  _: 1
                }),
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$89"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createElementVNode("img", {
                      src: _imports_10,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Adidas Women", -1),
                    _createElementVNode("span", { class: "text-body" }, "Outerwear", -1)
                  ])),
                  _: 1
                }),
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$85"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                    _createElementVNode("img", {
                      src: _imports_12,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "H&M Basic", -1),
                    _createElementVNode("span", { class: "text-body" }, "T-Shirts", -1)
                  ])),
                  _: 1
                }),
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$20"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap custom-shadow for-dark-rounded-bg rounded-3 border bg-white px-4 mb-4\" style=\"padding-top:11px;padding-bottom:11px;\"><span class=\"fs-12 fw-medium\">Showing 3 of 30 Results</span><nav aria-label=\"Page navigation example\"><ul class=\"pagination mb-0 justify-content-center\"><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Previous\"><i class=\"material-symbols-outlined\">keyboard_arrow_left</i></button></li><li class=\"page-item\"><button class=\"page-link active\">1</button></li><li class=\"page-item\"><button class=\"page-link\">2</button></li><li class=\"page-item\"><button class=\"page-link\">3</button></li><li class=\"page-item\"><a class=\"page-link\">4</a></li><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Next\"><i class=\"material-symbols-outlined\">keyboard_arrow_right</i></button></li></ul></nav></div>", 1))
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createElementVNode("img", {
                      src: _imports_6,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Levi's 501", -1),
                    _createElementVNode("span", { class: "text-body" }, "Pants", -1)
                  ])),
                  _: 1
                }),
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$89"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[34] || (_cache[34] = [
                    _createElementVNode("img", {
                      src: _imports_10,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Adidas Women", -1),
                    _createElementVNode("span", { class: "text-body" }, "Outerwear", -1)
                  ])),
                  _: 1
                }),
                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$85"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[36] || (_cache[36] = [
                    _createElementVNode("img", {
                      src: _imports_12,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "H&M Basic", -1),
                    _createElementVNode("span", { class: "text-body" }, "T-Shirts", -1)
                  ])),
                  _: 1
                }),
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$20"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[38] || (_cache[38] = [
                    _createElementVNode("img", {
                      src: _imports_5,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Apple iPhone 16", -1),
                    _createElementVNode("span", { class: "text-body" }, "Smartphones", -1)
                  ])),
                  _: 1
                }),
                _cache[39] || (_cache[39] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$799"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[40] || (_cache[40] = [
                    _createElementVNode("img", {
                      src: _imports_9,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Fitbit Charge", -1),
                    _createElementVNode("span", { class: "text-body" }, "Wearables", -1)
                  ])),
                  _: 1
                }),
                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$179"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[42] || (_cache[42] = [
                    _createElementVNode("img", {
                      src: _imports_11,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Galaxy Tab", -1),
                    _createElementVNode("span", { class: "text-body" }, "Tablets", -1)
                  ])),
                  _: 1
                }),
                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$649"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _cache[44] || (_cache[44] = _createStaticVNode("<div class=\"d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap custom-shadow for-dark-rounded-bg rounded-3 border bg-white px-4 mb-4\" style=\"padding-top:11px;padding-bottom:11px;\"><span class=\"fs-12 fw-medium\">Showing 3 of 30 Results</span><nav aria-label=\"Page navigation example\"><ul class=\"pagination mb-0 justify-content-center\"><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Previous\"><i class=\"material-symbols-outlined\">keyboard_arrow_left</i></button></li><li class=\"page-item\"><button class=\"page-link active\">1</button></li><li class=\"page-item\"><button class=\"page-link\">2</button></li><li class=\"page-item\"><button class=\"page-link\">3</button></li><li class=\"page-item\"><a class=\"page-link\">4</a></li><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Next\"><i class=\"material-symbols-outlined\">keyboard_arrow_right</i></button></li></ul></nav></div>", 1))
      ]),
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[45] || (_cache[45] = [
                    _createElementVNode("img", {
                      src: _imports_7,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Maybelline Lash", -1),
                    _createElementVNode("span", { class: "text-body" }, "Makeup", -1)
                  ])),
                  _: 1
                }),
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$29"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[47] || (_cache[47] = [
                    _createElementVNode("img", {
                      src: _imports_9,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Fitbit Charge", -1),
                    _createElementVNode("span", { class: "text-body" }, "Wearables", -1)
                  ])),
                  _: 1
                }),
                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$179"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[49] || (_cache[49] = [
                    _createElementVNode("img", {
                      src: _imports_13,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "L'Oréal Paris", -1),
                    _createElementVNode("span", { class: "text-body" }, "Makeup", -1)
                  ])),
                  _: 1
                }),
                _cache[50] || (_cache[50] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$69"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[51] || (_cache[51] = [
                    _createElementVNode("img", {
                      src: _imports_6,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Levi's 501", -1),
                    _createElementVNode("span", { class: "text-body" }, "Pants", -1)
                  ])),
                  _: 1
                }),
                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$89"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[53] || (_cache[53] = [
                    _createElementVNode("img", {
                      src: _imports_10,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Adidas Women", -1),
                    _createElementVNode("span", { class: "text-body" }, "Outerwear", -1)
                  ])),
                  _: 1
                }),
                _cache[54] || (_cache[54] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$85"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[55] || (_cache[55] = [
                    _createElementVNode("img", {
                      src: _imports_12,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "H&M Basic", -1),
                    _createElementVNode("span", { class: "text-body" }, "T-Shirts", -1)
                  ])),
                  _: 1
                }),
                _cache[56] || (_cache[56] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$20"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _cache[57] || (_cache[57] = _createStaticVNode("<div class=\"d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap custom-shadow for-dark-rounded-bg rounded-3 border bg-white px-4 mb-4\" style=\"padding-top:11px;padding-bottom:11px;\"><span class=\"fs-12 fw-medium\">Showing 3 of 30 Results</span><nav aria-label=\"Page navigation example\"><ul class=\"pagination mb-0 justify-content-center\"><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Previous\"><i class=\"material-symbols-outlined\">keyboard_arrow_left</i></button></li><li class=\"page-item\"><button class=\"page-link active\">1</button></li><li class=\"page-item\"><button class=\"page-link\">2</button></li><li class=\"page-item\"><button class=\"page-link\">3</button></li><li class=\"page-item\"><a class=\"page-link\">4</a></li><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Next\"><i class=\"material-symbols-outlined\">keyboard_arrow_right</i></button></li></ul></nav></div>", 1))
      ]),
      _createElementVNode("div", _hoisted_91, [
        _createElementVNode("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[58] || (_cache[58] = [
                    _createElementVNode("img", {
                      src: _imports_8,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Quaker Oats", -1),
                    _createElementVNode("span", { class: "text-body" }, "Breakfast", -1)
                  ])),
                  _: 1
                }),
                _cache[59] || (_cache[59] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$99"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("div", _hoisted_98, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[60] || (_cache[60] = [
                    _createElementVNode("img", {
                      src: _imports_6,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Levi's 501", -1),
                    _createElementVNode("span", { class: "text-body" }, "Pants", -1)
                  ])),
                  _: 1
                }),
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$89"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[62] || (_cache[62] = [
                    _createElementVNode("img", {
                      src: _imports_10,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Adidas Women", -1),
                    _createElementVNode("span", { class: "text-body" }, "Outerwear", -1)
                  ])),
                  _: 1
                }),
                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$85"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[64] || (_cache[64] = [
                    _createElementVNode("img", {
                      src: _imports_11,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "Galaxy Tab", -1),
                    _createElementVNode("span", { class: "text-body" }, "Tablets", -1)
                  ])),
                  _: 1
                }),
                _cache[65] || (_cache[65] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$649"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _createElementVNode("div", _hoisted_107, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[66] || (_cache[66] = [
                    _createElementVNode("img", {
                      src: _imports_12,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "H&M Basic", -1),
                    _createElementVNode("span", { class: "text-body" }, "T-Shirts", -1)
                  ])),
                  _: 1
                }),
                _cache[67] || (_cache[67] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$20"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                _createVNode(_component_RouterLink, {
                  to: "/ecommerce/product-details",
                  class: "d-block text-decoration-none mb-2"
                }, {
                  default: _withCtx(() => _cache[68] || (_cache[68] = [
                    _createElementVNode("img", {
                      src: _imports_13,
                      class: "rounded-2 mb-3",
                      alt: "product"
                    }, null, -1),
                    _createElementVNode("h3", { class: "fs-20 fw-medium mb-1" }, "L'Oréal Paris", -1),
                    _createElementVNode("span", { class: "text-body" }, "Makeup", -1)
                  ])),
                  _: 1
                }),
                _cache[69] || (_cache[69] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-end" }, [
                  _createElementVNode("span", { class: "fs-24 fw-medium text-success-60 lh-1 position-relative top-3" }, "$69"),
                  _createElementVNode("button", {
                    class: "rounded-1 border-0 p-0 text-center text-primary fs-24",
                    style: {"background-color":"#dde4ff","width":"35px","height":"35px","line-height":"35px"}
                  }, [
                    _createElementVNode("i", { class: "ri-shopping-cart-fill" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _cache[70] || (_cache[70] = _createStaticVNode("<div class=\"d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap custom-shadow for-dark-rounded-bg rounded-3 border bg-white px-4 mb-4\" style=\"padding-top:11px;padding-bottom:11px;\"><span class=\"fs-12 fw-medium\">Showing 1 of 30 Results</span><nav aria-label=\"Page navigation example\"><ul class=\"pagination mb-0 justify-content-center\"><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Previous\"><i class=\"material-symbols-outlined\">keyboard_arrow_left</i></button></li><li class=\"page-item\"><button class=\"page-link active\">1</button></li><li class=\"page-item\"><button class=\"page-link\">2</button></li><li class=\"page-item\"><button class=\"page-link\">3</button></li><li class=\"page-item\"><a class=\"page-link\">4</a></li><li class=\"page-item\"><button class=\"page-link icon hover-bg\" aria-label=\"Next\"><i class=\"material-symbols-outlined\">keyboard_arrow_right</i></button></li></ul></nav></div>", 1))
      ])
    ])
  ], 64))
}